import { use } from 'react';
import { DeviceDetailsProvider } from 'shared/providers/device-details/providers/device-details-provider';

import DeviceDetailsPopup from 'features/device/device-details/views/device-details-popup.component';
import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import IPUnitConfigurationComponent from 'features/systems/ip-unit/components/ip-unit-configuration-component/ip-unit-configuration-component';
import IPUnitDoorEntrances from 'features/systems/ip-unit/components/ip-unit-door-entrances/ip-unit-door-entrances';
import IPUnitIOFunctionality from 'features/systems/ip-unit/components/ip-unit-io-functionality/ip-unit-io-functionality';
import IPUnitLocation from 'features/systems/ip-unit/components/ip-unit-location/ip-unit-location';
import IPUnitWirelessDevices from 'features/systems/ip-unit/components/ip-unit-wireless-devices/ip-unit-wireless-devices';
import IPUnitProviderContext from 'features/systems/ip-unit/providers/contexts/ip-unit-provider-context';

const IPUnitConfiguration = (): React.JSX.Element => {
  const { selectedDeviceId } = use(IPUnitProviderContext);

  const {
    systemsDetailsHook: { refreshSystem },
  } = useSystemsContextProvider();

  return (
    <>
      <IPUnitConfigurationComponent />
      <IPUnitIOFunctionality />
      <IPUnitDoorEntrances />
      <IPUnitWirelessDevices />
      <IPUnitLocation />
      {selectedDeviceId && (
        <DeviceDetailsProvider deviceId={selectedDeviceId} initialViewingMode={'viewing'}>
          <DeviceDetailsPopup onCloseCallback={() => refreshSystem()} />
        </DeviceDetailsProvider>
      )}
    </>
  );
};

export default IPUnitConfiguration;
